import React, { useState } from "react";
import { Link } from "react-scroll";
import { useNavigate } from "react-router-dom";

import Navbar from "./Navbar";
import Footer from "./Footer";

import "./Training.css";
import trainingImg from "./training.png";

import {
  FaReact,
  FaDatabase,
  FaTasks,
  FaChevronDown,
  FaChevronUp,
  FaUserGraduate,
  FaLaptopCode,
  FaBuilding,
  FaCertificate,
  FaClipboardCheck,
  FaChalkboardTeacher,
  FaProjectDiagram

} from "react-icons/fa";

import { SiDotnet } from "react-icons/si";

export default function Training() {

  const navigate = useNavigate();

  const [openFAQ, setOpenFAQ] = useState(null);

  const handleContact = () => {

    navigate("/", {

      state: {

        scrollTo: "contact",

      },

    });

  };

  const faqs = [

    {

      question: "Who can enroll in these training programs?",

      answer:

        "Students, fresh graduates, working professionals and corporate teams looking to enhance their technical skills can enroll."

    },

    {

      question: "Are the programs practical or theory-based?",

      answer:

        "Our programs focus on hands-on learning through live projects, assignments, case studies and real-world industry scenarios."

    },

    {

      question: "Do you provide certificates after completion?",

      answer:

        "Yes. Participants receive an E-Forum Training Certificate upon successful completion of the course."

    },

    {

      question: "Are customized corporate training programs available?",

      answer:

        "Yes. We offer customized corporate training programs designed according to organizational requirements."

    },

    {

      question: "What is the mode of training?",

      answer:

        "Training programs are available in both online and classroom modes depending on the course and batch schedule."

    },

    {

      question: "How can I enroll?",

      answer:

        "You can contact us through our website or email our training team to receive the complete syllabus, batch schedule and enrollment details."

    }

  ];

  return (

    <>
      <Navbar />

      {/* ================= HERO ================= */}


<section className="training-hero">

  <div className="training-hero-content">

    <span className="hero-tag">
      PROFESSIONAL TRAINING & CERTIFICATION
    </span>

    <h1>
      Learn.
      <br />
      Build.
      <br />
      <span>Get Industry Ready.</span>
    </h1>

    <p>
      E-Forum Systems provides industry-focused technical training
      programs that equip students, professionals and corporate teams
      with practical skills, real-world project experience and
      internationally relevant technologies.
    </p>

    <div className="hero-features">

      <div className="hero-feature">
        <FaUserGraduate />
        <span>Expert Trainers</span>
      </div>

      <div className="hero-feature">
        <FaLaptopCode />
        <span>Live Projects</span>
      </div>

      <div className="hero-feature">
        <FaCertificate />
        <span>Certification</span>
      </div>

      <div className="hero-feature">
        <FaBuilding />
        <span>Corporate Training</span>
      </div>

    </div>

    <div className="hero-buttons">

      <Link
        to="training-programs"
        smooth={true}
        duration={700}
        offset={-80}
      >
        <button className="btn-primary">
          Explore Programs
        </button>
      </Link>

      <button
        className="btn-secondary"
        onClick={handleContact}
      >
        Enroll Now
      </button>

    </div>

  </div>

  <div className="training-hero-image">

    <img
      src={trainingImg}
      alt="Professional Training"
    />

  </div>

</section>
{/* ================= ABOUT ================= */}

<section className="training-about">

  <div className="about-image">
    <img
      src={trainingImg}
      alt="Professional Training"
    />
  </div>

  <div className="about-content">

    <span className="section-tag">
      ABOUT OUR TRAINING
    </span>

    <h2>
      Empowering Professionals Through
      <span> Industry-Focused Learning</span>
    </h2>

    <p>
      E-Forum Systems delivers measurable business value through
      innovative technology consulting and professional training
      programs designed to bridge the gap between academic learning
      and industry expectations.
    </p>

    <p>
      Our programs combine experienced instructors, hands-on projects,
      real-world case studies and modern technologies to prepare
      professionals for successful careers.
    </p>

    <div className="about-grid">

      <div className="about-card">
        <FaUserGraduate className="about-icon"/>
        <h3>Expert Trainers</h3>
        <p>Learn from experienced industry professionals.</p>
      </div>

      <div className="about-card">
        <FaLaptopCode className="about-icon"/>
        <h3>Hands-on Projects</h3>
        <p>Practical assignments and real-world development.</p>
      </div>

      <div className="about-card">
        <FaCertificate className="about-icon"/>
        <h3>Professional Certificate</h3>
        <p>Receive certification after successful completion.</p>
      </div>

      <div className="about-card">
        <FaBuilding className="about-icon"/>
        <h3>Corporate Training</h3>
        <p>Customized programs for organizations and teams.</p>
      </div>

    </div>

  </div>

</section>
{/* ================= TRAINING PROGRAMS ================= */}

{/* ================= TRAINING PROGRAMS ================= */}

<section id="training-programs" className="training-programs">

  <div className="section-heading">

    <span>OUR PROGRAMS</span>

    <h2>Professional Training Programs</h2>

    <p>
      Industry-oriented certification programs designed to help students,
      professionals and organizations master modern technologies through
      practical implementation and real-world projects.
    </p>

  </div>

  <div className="programs-grid">

    {/* MERN */}

    <div className="program-card">

      <div className="program-icon">
        <FaReact />
      </div>

      <h3>MERN Full Stack Developer</h3>

      <p>
        Become a full-stack developer by mastering modern web technologies
        used by leading software companies.
      </p>

      <ul>
        <li>✔ React, Hooks & Redux</li>
        <li>✔ Node.js & Express APIs</li>
        <li>✔ MongoDB Database</li>
        <li>✔ JWT Authentication</li>
        <li>✔ AWS / Vercel Deployment</li>
      </ul>

      <button
        className="program-btn"
        onClick={handleContact}
      >
        Enroll Now
      </button>

    </div>

    {/* Microsoft */}

    <div className="program-card">

      <div className="program-icon">
        <SiDotnet />
      </div>

      <h3>Microsoft Full Stack Developer</h3>

      <p>
        Build enterprise-grade applications using Microsoft's latest
        development ecosystem.
      </p>

      <ul>
        <li>✔ C# Programming</li>
        <li>✔ ASP.NET Core</li>
        <li>✔ Entity Framework</li>
        <li>✔ Angular / Blazor</li>
        <li>✔ Azure Cloud</li>
      </ul>

      <button
        className="program-btn"
        onClick={handleContact}
      >
        Enroll Now
      </button>

    </div>

    {/* DBA */}

    <div className="program-card">

      <div className="program-icon">
        <FaDatabase />
      </div>

      <h3>Database Administration</h3>

      <p>
        Learn to administer enterprise databases with security,
        optimization and high availability.
      </p>

      <ul>
        <li>✔ Installation & Configuration</li>
        <li>✔ Backup & Recovery</li>
        <li>✔ Performance Tuning</li>
        <li>✔ Security Management</li>
        <li>✔ High Availability</li>
      </ul>

      <button
        className="program-btn"
        onClick={handleContact}
      >
        Enroll Now
      </button>

    </div>

    {/* PM */}

    <div className="program-card">

      <div className="program-icon">
        <FaTasks />
      </div>

      <h3>Project Management Basics</h3>

      <p>
        Learn Agile, Scrum and modern project management practices used
        across industries.
      </p>

      <ul>
        <li>✔ Agile & Scrum</li>
        <li>✔ Waterfall</li>
        <li>✔ Risk Management</li>
        <li>✔ Cost Planning</li>
        <li>✔ Stakeholder Management</li>
      </ul>

      <button
        className="program-btn"
        onClick={handleContact}
      >
        Enroll Now
      </button>

    </div>

  </div>

</section>

{/* ================= WHY CHOOSE ================= */}

<section className="why-training">

  <div className="section-heading">

    <span>WHY CHOOSE US</span>

    <h2>Why Learn With E-Forum Systems?</h2>

    <p>
      Our training programs combine industry expertise, practical learning
      and career-oriented mentorship to prepare learners for today's
      technology landscape.
    </p>

  </div>

  <div className="why-grid">

    <div className="why-card">

      <FaUserGraduate className="why-icon"/>

      <h3>Industry Experts</h3>

      <p>
        Learn directly from experienced professionals with real project
        exposure.
      </p>

    </div>

    <div className="why-card">

      <FaLaptopCode className="why-icon"/>

      <h3>Hands-on Projects</h3>

      <p>
        Work on practical assignments and industry-based applications
        instead of only theory.
      </p>

    </div>

    <div className="why-card">

      <FaCertificate className="why-icon"/>

      <h3>Professional Certification</h3>

      <p>
        Receive certification after successful completion of every
        training program.
      </p>

    </div>

    <div className="why-card">

      <FaBuilding className="why-icon"/>

      <h3>Corporate Training</h3>

      <p>
        Customized learning solutions for organizations and enterprise
        teams.
      </p>

    </div>

    <div className="why-card">

      <FaReact className="why-icon"/>

      <h3>Latest Technologies</h3>

      <p>
        Learn modern development frameworks and cloud technologies used
        by leading companies.
      </p>

    </div>

    <div className="why-card">

      <FaTasks className="why-icon"/>

      <h3>Career Focused</h3>

      <p>
        Gain job-ready skills through structured learning paths,
        mentoring and project-based assessments.
      </p>

    </div>

  </div>

</section>


{/* ================= TRAINING METHODOLOGY ================= */}

<section className="training-process">

  <div className="section-heading">

    <span>OUR METHODOLOGY</span>

    <h2>How We Deliver Training</h2>

    <p>
      Our structured learning approach combines expert guidance,
      practical implementation and continuous assessment to ensure
      every learner gains real-world skills.
    </p>

  </div>

  <div className="process-grid">

    <div className="process-card">

      <div className="process-icon">
        <FaClipboardCheck />
      </div>

      <h3>Skill Assessment</h3>

      <p>
        Evaluate learners' existing knowledge and define personalized
        learning objectives.
      </p>

    </div>

    <div className="process-card">

      <div className="process-icon">
        <FaChalkboardTeacher />
      </div>

      <h3>Instructor-led Sessions</h3>

      <p>
        Interactive classroom and online sessions covering concepts,
        best practices and industry examples.
      </p>

    </div>

    <div className="process-card">

      <div className="process-icon">
        <FaLaptopCode />
      </div>

      <h3>Hands-on Practice</h3>

      <p>
        Coding exercises, assignments and guided laboratory sessions
        for practical learning.
      </p>

    </div>

    <div className="process-card">

      <div className="process-icon">
        <FaProjectDiagram />
      </div>

      <h3>Live Industry Projects</h3>

      <p>
        Build real-world applications that simulate professional
        software development environments.
      </p>

    </div>

    <div className="process-card">

      <div className="process-icon">
        <FaTasks />
      </div>

      <h3>Continuous Evaluation</h3>

      <p>
        Measure progress using assignments, quizzes, code reviews
        and mentor feedback.
      </p>

    </div>

    <div className="process-card">

      <div className="process-icon">
        <FaCertificate />
      </div>

      <h3>Certification</h3>

      <p>
        Earn an E-Forum Professional Training Certificate after
        successful completion of the program.
      </p>

    </div>

  </div>

</section>

  



{/* ================= FAQ ================= */}

<section className="training-faq">

  <div className="faq-left">

    <span className="section-tag">
      FAQ
    </span>

    <h2>
      Frequently Asked
      <span> Questions</span>
    </h2>

    <p>
      Have questions about our professional training programs?
      Here are answers to the most common queries from students,
      professionals and corporate teams.
    </p>

    <button
      className="faq-contact-btn"
      onClick={handleContact}
    >
      Contact Training Team
    </button>

  </div>

  <div className="faq-right">

    {faqs.map((faq, index) => (

      <div className="faq-item" key={index}>

        <button
          className="faq-question"
          onClick={() =>
            setOpenFAQ(openFAQ === index ? null : index)
          }
        >

          <span>{faq.question}</span>

          {openFAQ === index
            ? <FaChevronUp />
            : <FaChevronDown />
          }

        </button>

        <div
          className={`faq-answer ${
            openFAQ === index ? "show" : ""
          }`}
        >

          <p>{faq.answer}</p>

        </div>

      </div>

    ))}

  </div>

</section>
      <Footer />

    </>
  );
}

